import axios from 'axios';
import i18n from '../../i18n';

const baseURL =
  process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : '';

const service = {
  async getOrganizationDetails(companyId) {
    const resp = await axios
      .get(
        baseURL +
          '/api/legacy-signup/organizationDetails?organizationId=' +
          companyId
      )
      .then(response => {
        return mapFromGetOrganizationDetails(response.data);
      })
      .catch(error => {
        return { error: error };
      });

    return resp;
  },

  async getDeliveryDays(postalCode) {
    const resp = await axios
      .get(baseURL + '/api/legacy-signup/deliveryDays?zipCode=' + postalCode)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });

    var deliveryDays = [{ label: '', value: '' }];
    if (resp.monday === true) {
      deliveryDays.push({ label: i18n.t('weekdays.monday'), value: 'monday' });
    }
    if (resp.tuesday === true) {
      deliveryDays.push({
        label: i18n.t('weekdays.tuesday'),
        value: 'tuesday'
      });
    }
    if (resp.wednesday === true) {
      deliveryDays.push({
        label: i18n.t('weekdays.wednesday'),
        value: 'wednesday'
      });
    }
    if (resp.thursday === true) {
      deliveryDays.push({
        label: i18n.t('weekdays.thursday'),
        value: 'thursday'
      });
    }
    if (resp.friday === true) {
      deliveryDays.push({ label: i18n.t('weekdays.friday'), value: 'friday' });
    }
    if (resp.saturday === true) {
      deliveryDays.push({
        label: i18n.t('weekdays.saturday'),
        value: 'saturday'
      });
    }
    if (resp.sunday === true) {
      deliveryDays.push({ label: i18n.t('weekdays.sunday'), value: 'sunday' });
    }
    return deliveryDays;
  },

  async getZipCodeInfo(postalCode) {
    const resp = await axios
      .get(baseURL + '/api/legacy-signup/zipCodeInfo?zipCode=' + postalCode)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });

    return resp;
  },

  async signup(data) {
    data = toFormData(normalizeData(mapToServer(data)));

    const resp = await axios.post(baseURL + '/api/legacy-signup/signup', data);
    return resp.data;
  }
};

const mapFromGetOrganizationDetails = ({
  companyId,
  companyName,
  companyFriendlyName,
  contactName,
  contactPhone,
  contactEmail,
  deliveryAddress,
  deliveryZipCode,
  deliveryTown,
  mailingAddress,
  mailingZipCode,
  mailingTown,
  invoiceEmail
}) => ({
  companyId: companyId,
  companyName: companyName || '',
  companyFriendlyName: companyFriendlyName || '',
  contactName: contactName || '',
  contactPhone: contactPhone ? contactPhone.replace(/\s+/g, '') || '' : '',
  contactEmail: contactEmail || '',
  contactEmailConfirmation: contactEmail || '',
  invoiceEmail: invoiceEmail || '',
  deliveryAddress: deliveryAddress || '',
  deliveryZipCode: deliveryZipCode || '',
  deliveryCity: deliveryTown || ''
});

const mapToServer = ({
  companyId,
  companyName,

  isNewOwner,
  prevCustomerId,
  takeoverDate,

  contactName,
  contactPhone,
  contactEmail,
  contactEmailConfirmation,

  companyFriendlyName,
  legalOwnerName,
  outletType,
  season,
  eventStartDate,
  eventEndDate,
  preferredContactPeriod,

  deliveryAddress,
  deliveryZipCode,
  deliveryCity,
  deliveryDay,
  deliveryPeriod,
  deliveryNotes,

  invoiceEmail,
  enableEamElectronicInvoice,
  paymentRemindersEmail,

  checkTOS,
  checkPaymentTerms,
  checkNewsletterSubscription,
  checkSmsReminder,
  checkMarketingCommunication
}) => ({
  basicData: {
    companyId: companyId,
    companyName: companyName
  },
  ownerChangeData: {
    isOwnerChange: isNewOwner,
    previousOwner: prevCustomerId,
    acquisitionDate: takeoverDate
  },
  contactData: {
    contactName: contactName,
    contactPhone: contactPhone,
    contactEmail: contactEmail,
    contactEmailConfirmation: contactEmailConfirmation
  },
  operationData: {
    companyFriendlyName: companyFriendlyName,
    legalOwnerName: legalOwnerName,
    outletType: outletType,
    season: season,
    eventStartDate: season === 'event' ? eventStartDate : null,
    eventEndDate: season === 'event' ? eventEndDate : null,
    preferredContactPeriod: preferredContactPeriod
  },
  deliveryData: {
    deliveryAddress: deliveryAddress,
    deliveryZipCode: deliveryZipCode,
    deliveryTown: deliveryCity,
    deliveryDay: deliveryDay,
    deliveryPeriod: deliveryPeriod,
    deliveryNotes: deliveryNotes
  },
  mailingData: {
    hasDifferentMailingAddress: false
  },
  billingData: {
    invoiceEmail: invoiceEmail,
    enableEamElectronicInvoice: enableEamElectronicInvoice,
    paymentRemindersEmail: paymentRemindersEmail
  },
  gdprCheckbox: checkTOS,
  paymentTermsCheckbox: checkPaymentTerms,
  newsletterSubscriptionCheckbox: checkNewsletterSubscription,
  generalSmsReminderCheckbox: checkSmsReminder,
  generalMarketingCommunicationCheckbox: checkMarketingCommunication
});

const normalizeData = (data, parentKey) => {
  let result = {};

  if (data) {
    if (data.__proto__.constructor.name === 'File') {
      return {
        [parentKey]: data
      };
    }

    Object.keys(data).forEach(key => {
      let val = data[key];

      if (parseInt(key) || key === '0') {
        key = parentKey;

        result[key] = result[key] ? result[key] : [];

        result[key].push(val);
      } else {
        if (parentKey) {
          key = parentKey + '.' + key;
        }

        if (typeof val === 'object') {
          const childResult = normalizeData(val, key);

          result = {
            ...result,
            ...childResult
          };
        } else {
          result[key] = val;
        }
      }
    });
  }

  return result;
};

const toFormData = data => {
  let fd = new FormData();

  Object.keys(data).forEach(key => {
    if (key === 'alcoholData.liquorLicenses') {
      data[key].map(file => {
        fd.append(key, file, file.name);
        return file;
      });

      return;
    }

    fd.append(key, data[key]);
  });

  return fd;
};

export default service;
